import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Space,
  Typography,
} from "antd";
import { LockOutlined, LoginOutlined, MailOutlined } from "@ant-design/icons";
import { signIn } from "../auth";
import { useAuth } from "../contexts/AuthContext";

const Login: React.FC = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) {
    return <Navigate to="/main" replace />;
  }

  const handleLogin = async (values: { email: string; password: string }) => {
    setLoading(true);
    setError("");

    try {
      const credentials = await signIn(values.email, values.password);
      sessionStorage.removeItem(
        `pedidos-ya-link-notice:${credentials.user.uid}`,
      );
    } catch {
      setError("Error iniciando sesión. Revisa tu correo/contraseña.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: 16,
        display: "grid",
        placeItems: "center",
        background:
          "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.18), transparent 24%), radial-gradient(circle at 80% 30%, rgba(124,92,252,0.3), transparent 28%), linear-gradient(180deg, #2e4fb3 0%, var(--dashboard-page-bg) 50%, #19285f 100%)",
      }}
    >
      <Row justify="center" align="middle" style={{ width: "100%" }}>
        <Col xs={24} sm={22} md={16} lg={12} xl={10} xxl={8}>
          <Card
            className="app-glass hero-panel"
            bordered={false}
            style={{ borderRadius: 28, overflow: "hidden" }}
            bodyStyle={{ padding: 0 }}
          >
            <div
              style={{
                padding: 28,
                background:
                  "linear-gradient(135deg, rgba(47,43,116,0.96) 0%, rgba(124,92,252,0.88) 100%)",
                color: "#fff",
              }}
            >
              <Space direction="vertical" size={8} style={{ width: "100%" }}>
                <Typography.Text
                  style={{
                    color: "rgba(255,255,255,0.82)",
                    fontWeight: 700,
                    letterSpacing: 1.2,
                    textTransform: "uppercase",
                  }}
                >
                  Desafío
                </Typography.Text>
                <Typography.Title
                  level={1}
                  style={{ margin: 0, color: "#fff" }}
                >
                  Ingresar al panel
                </Typography.Title>
                <Typography.Paragraph
                  style={{
                    margin: 0,
                    color: "rgba(255,255,255,0.86)",
                    fontSize: 16,
                  }}
                >
                  Accedé a tu progreso, recompensas y perfil en una experiencia
                  clara y mobile-first.
                </Typography.Paragraph>
              </Space>
            </div>

            <div style={{ padding: 28 }}>
              {error ? (
                <Alert
                  type="error"
                  showIcon
                  message={error}
                  style={{ marginBottom: 20 }}
                />
              ) : null}

              <Form
                layout="vertical"
                onFinish={handleLogin}
                requiredMark={false}
                size="large"
              >
                <Form.Item
                  name="email"
                  label={<Typography.Text strong>Email</Typography.Text>}
                  rules={[{ required: true, message: "Ingresá tu email" }]}
                >
                  <Input
                    prefix={<MailOutlined />}
                    placeholder="tu@email.com"
                    autoComplete="email"
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  label={<Typography.Text strong>Contraseña</Typography.Text>}
                  rules={[{ required: true, message: "Ingresá tu contraseña" }]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="••••••••"
                    autoComplete="current-password"
                  />
                </Form.Item>

                <Button
                  htmlType="submit"
                  type="primary"
                  block
                  loading={loading}
                  icon={<LoginOutlined />}
                  style={{
                    height: 48,
                    borderRadius: 16,
                    fontWeight: 800,
                    marginTop: 8,
                    background: "var(--dashboard-yellow)",
                    borderColor: "var(--dashboard-yellow-dark)",
                    color: "var(--dashboard-header-blue)",
                  }}
                >
                  Iniciar sesión
                </Button>
              </Form>

              <Divider
                style={{
                  margin: "24px 0 14px",
                  borderColor: "rgba(47,43,116,0.12)",
                }}
              />
              <Typography.Text style={{ color: "var(--dashboard-text)" }}>
                Si no podés entrar, revisá el correo y la contraseña cargados en
                el sistema.
              </Typography.Text>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
